export default "__VITE_ASSET__Ck8O8rmh__"